/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Case } from '../models/Case';
import type { CaseItem } from '../models/CaseItem';
import type { CaseItemsResponse } from '../models/CaseItemsResponse';
import type { OddsHistoryResponse } from '../models/OddsHistoryResponse';
import type { WonItem } from '../models/WonItem';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CasesService {
    /**
     * List all available cases
     * Returns a list of all active cases available for opening
     * @returns Case List of cases
     * @throws ApiError
     */
    public static getV1Cases(): CancelablePromise<Array<Case>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/cases',
        });
    }
    /**
     * Get items in a specific case
     * Returns available items and best drops for the case
     * @param caseId Case ID
     * @returns (CaseItemsResponse | Array<CaseItem>) Case items payload (items + best drops)
     * @throws ApiError
     */
    public static getV1CasesItems(
        caseId: string,
    ): CancelablePromise<Array<CaseItem> | CaseItemsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/cases/{caseId}/items',
            path: {
                'caseId': caseId,
            },
            errors: {
                404: `Case not found`,
            },
        });
    }
    /**
     * Get historical odds for a case
     * Returns paginated historical snapshots of case odds with item prices and ticket ranges
     * @param caseId Case ID
     * @param page Page number (0-indexed)
     * @param limit Number of snapshots per page
     * @returns OddsHistoryResponse Historical odds snapshots
     * @throws ApiError
     */
    public static getV1CasesOddsHistory(
        caseId: string,
        page?: number,
        limit: number = 1,
    ): CancelablePromise<OddsHistoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/cases/{caseId}/odds-history',
            path: {
                'caseId': caseId,
            },
            query: {
                'page': page,
                'limit': limit,
            },
            errors: {
                404: `No odds history found for this case`,
            },
        });
    }
    /**
     * Open a case
     * Opens one or more cases and returns the won items
     * @param caseId Case ID
     * @param requestBody
     * @returns any Case opening result
     * @throws ApiError
     */
    public static postV1CasesOpen(
        caseId: string,
        requestBody: {
            /**
             * Whether to use case tokens instead of balance
             */
            useCaseToken: boolean;
            /**
             * Number of cases to open (1-5 or 10)
             */
            amount: 1 | 2 | 3 | 4 | 5 | 10;
        },
    ): CancelablePromise<{
        /**
         * Random.org ID for provably fair verification
         */
        randomId?: string;
        /**
         * Seed used for the opening
         */
        randomSeed?: string;
        items?: Array<WonItem>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/cases/{caseId}/open',
            path: {
                'caseId': caseId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid parameters or insufficient balance`,
                401: `Not authenticated`,
            },
        });
    }
}
